import { render, staticRenderFns } from "./WorkspaceManagementModal.vue?vue&type=template&id=806d7196&"
import script from "./WorkspaceManagementModal.vue?vue&type=script&lang=js&"
export * from "./WorkspaceManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkspaceManagementModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/WorkspaceManagementModal.vue
// module id = 1675
// module chunks = 1